/**
 * Generated by orval v8.1.0 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DisplayAgelessHostConfiguration,
  DisplayAgelessWebsiteEmbedSettingsResponse,
  DisplayAiAutoReplySettingsResponse,
  DisplayGeneratedAgelessMarketingSetupTokenResponse,
  DisplayGeneratedAgelessWebsiteEmbedTokenResponse,
  DisplayValidatedAgelessWebsiteEmbedTokenResponse,
  GenerateAgelessMarketingSetupTokenRequest,
  GenerateAgelessWebsiteEmbedTokenRequest,
  GetAiAutoReplySettingsParams,
  GetWebsiteEmbedSettingsParams,
  ProblemDetails,
  SendAgelessWebsiteEmbedInstructionsRequest,
  SetAllowedOriginsForAgelessWebsiteEmbedRequest,
  SetBeautyScoreDisplayNameRequest,
  ValidateWebsiteEmbedTokenParams
} from '.././model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




/**
 * @summary Set the beauty score display name for an Ageless platform.
 */
export const setBeautyScoreDisplayName = (
    platformId: string,
    setBeautyScoreDisplayNameRequest: SetBeautyScoreDisplayNameRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/beauty-score-display-name`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setBeautyScoreDisplayNameRequest, signal
    },
      );
    }
  


export const getSetBeautyScoreDisplayNameMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBeautyScoreDisplayName>>, TError,{platformId: string;data: SetBeautyScoreDisplayNameRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setBeautyScoreDisplayName>>, TError,{platformId: string;data: SetBeautyScoreDisplayNameRequest}, TContext> => {

const mutationKey = ['setBeautyScoreDisplayName'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setBeautyScoreDisplayName>>, {platformId: string;data: SetBeautyScoreDisplayNameRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  setBeautyScoreDisplayName(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetBeautyScoreDisplayNameMutationResult = NonNullable<Awaited<ReturnType<typeof setBeautyScoreDisplayName>>>
    export type SetBeautyScoreDisplayNameMutationBody = SetBeautyScoreDisplayNameRequest
    export type SetBeautyScoreDisplayNameMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Set the beauty score display name for an Ageless platform.
 */
export const useSetBeautyScoreDisplayName = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBeautyScoreDisplayName>>, TError,{platformId: string;data: SetBeautyScoreDisplayNameRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setBeautyScoreDisplayName>>,
        TError,
        {platformId: string;data: SetBeautyScoreDisplayNameRequest},
        TContext
      > => {
      return useMutation(getSetBeautyScoreDisplayNameMutationOptions(options));
    }
    /**
 * @summary Sets the allowed origins for a platform's Ageless website embed.
 */
export const setWebsiteEmbedAllowedOrigins = (
    platformId: string,
    setAllowedOriginsForAgelessWebsiteEmbedRequest: SetAllowedOriginsForAgelessWebsiteEmbedRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/website-embed/allowed-origins`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAllowedOriginsForAgelessWebsiteEmbedRequest, signal
    },
      );
    }
  


export const getSetWebsiteEmbedAllowedOriginsMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWebsiteEmbedAllowedOrigins>>, TError,{platformId: string;data: SetAllowedOriginsForAgelessWebsiteEmbedRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setWebsiteEmbedAllowedOrigins>>, TError,{platformId: string;data: SetAllowedOriginsForAgelessWebsiteEmbedRequest}, TContext> => {

const mutationKey = ['setWebsiteEmbedAllowedOrigins'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setWebsiteEmbedAllowedOrigins>>, {platformId: string;data: SetAllowedOriginsForAgelessWebsiteEmbedRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  setWebsiteEmbedAllowedOrigins(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetWebsiteEmbedAllowedOriginsMutationResult = NonNullable<Awaited<ReturnType<typeof setWebsiteEmbedAllowedOrigins>>>
    export type SetWebsiteEmbedAllowedOriginsMutationBody = SetAllowedOriginsForAgelessWebsiteEmbedRequest
    export type SetWebsiteEmbedAllowedOriginsMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Sets the allowed origins for a platform's Ageless website embed.
 */
export const useSetWebsiteEmbedAllowedOrigins = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWebsiteEmbedAllowedOrigins>>, TError,{platformId: string;data: SetAllowedOriginsForAgelessWebsiteEmbedRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setWebsiteEmbedAllowedOrigins>>,
        TError,
        {platformId: string;data: SetAllowedOriginsForAgelessWebsiteEmbedRequest},
        TContext
      > => {
      return useMutation(getSetWebsiteEmbedAllowedOriginsMutationOptions(options));
    }
    /**
 * @summary Enables the Ageless website embed for a platform.
 */
export const enableWebsiteEmbed = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/website-embed/enable`, method: 'PUT', signal
    },
      );
    }
  


export const getEnableWebsiteEmbedMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableWebsiteEmbed>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableWebsiteEmbed>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['enableWebsiteEmbed'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableWebsiteEmbed>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  enableWebsiteEmbed(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type EnableWebsiteEmbedMutationResult = NonNullable<Awaited<ReturnType<typeof enableWebsiteEmbed>>>
    
    export type EnableWebsiteEmbedMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Enables the Ageless website embed for a platform.
 */
export const useEnableWebsiteEmbed = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableWebsiteEmbed>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof enableWebsiteEmbed>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getEnableWebsiteEmbedMutationOptions(options));
    }
    /**
 * @summary Disables the Ageless website embed for a platform.
 */
export const disableWebsiteEmbed = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/website-embed/disable`, method: 'PUT', signal
    },
      );
    }
  


export const getDisableWebsiteEmbedMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableWebsiteEmbed>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableWebsiteEmbed>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['disableWebsiteEmbed'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableWebsiteEmbed>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  disableWebsiteEmbed(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DisableWebsiteEmbedMutationResult = NonNullable<Awaited<ReturnType<typeof disableWebsiteEmbed>>>
    
    export type DisableWebsiteEmbedMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Disables the Ageless website embed for a platform.
 */
export const useDisableWebsiteEmbed = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableWebsiteEmbed>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof disableWebsiteEmbed>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getDisableWebsiteEmbedMutationOptions(options));
    }
    /**
 * @summary Enables AI auto-reply for a platform.
 */
export const enableAiAutoReply = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/ai-auto-reply/enable`, method: 'PUT', signal
    },
      );
    }
  


export const getEnableAiAutoReplyMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAiAutoReply>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAiAutoReply>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['enableAiAutoReply'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAiAutoReply>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  enableAiAutoReply(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type EnableAiAutoReplyMutationResult = NonNullable<Awaited<ReturnType<typeof enableAiAutoReply>>>
    
    export type EnableAiAutoReplyMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Enables AI auto-reply for a platform.
 */
export const useEnableAiAutoReply = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAiAutoReply>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof enableAiAutoReply>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getEnableAiAutoReplyMutationOptions(options));
    }
    /**
 * @summary Disables AI auto-reply for a platform.
 */
export const disableAiAutoReply = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/ai-auto-reply/disable`, method: 'PUT', signal
    },
      );
    }
  


export const getDisableAiAutoReplyMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAiAutoReply>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableAiAutoReply>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['disableAiAutoReply'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableAiAutoReply>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  disableAiAutoReply(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DisableAiAutoReplyMutationResult = NonNullable<Awaited<ReturnType<typeof disableAiAutoReply>>>
    
    export type DisableAiAutoReplyMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Disables AI auto-reply for a platform.
 */
export const useDisableAiAutoReply = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAiAutoReply>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof disableAiAutoReply>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getDisableAiAutoReplyMutationOptions(options));
    }
    /**
 * @summary Retrieve whether AI auto-reply is enabled for a platform. Opt-in: an unconfigured platform
returns `Enabled = false` (not 404), so the settings tab renders the toggle off by default.
 */
export const getAiAutoReplySettings = (
    platformId: string,
    params?: GetAiAutoReplySettingsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAiAutoReplySettingsResponse>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/ai-auto-reply`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAiAutoReplySettingsQueryKey = (platformId: string,
    params?: GetAiAutoReplySettingsParams,) => {
    return [
    `/api/v1/ageless/platforms/features/${platformId}/ai-auto-reply`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetAiAutoReplySettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: GetAiAutoReplySettingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiAutoReplySettingsQueryKey(platformId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiAutoReplySettings>>> = ({ signal }) => getAiAutoReplySettings(platformId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAiAutoReplySettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAiAutoReplySettings>>>
export type GetAiAutoReplySettingsQueryError = ErrorType<ProblemDetails>


/**
 * @summary Retrieve whether AI auto-reply is enabled for a platform. Opt-in: an unconfigured platform
returns `Enabled = false` (not 404), so the settings tab renders the toggle off by default.
 */

export function useGetAiAutoReplySettings<TData = Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetAiAutoReplySettingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAiAutoReplySettingsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Send Ageless website embed setup instructions email to a recipient on
behalf of the requesting admin user. The frontend supplies subject + a
base64-encoded body (base64 keeps the embed snippet's script/inline
handlers opaque so the upstream WAF does not flag the request as XSS and
drop it); the backend decodes the body, prepends a server-controlled
prelude, and sends via the canonical email pipeline with Reply-To set to
the admin's email and the admin BCC'd a copy of the outbound message.
 */
export const sendWebsiteEmbedInstructions = (
    platformId: string,
    sendAgelessWebsiteEmbedInstructionsRequest: SendAgelessWebsiteEmbedInstructionsRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/website-embed/send-instructions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendAgelessWebsiteEmbedInstructionsRequest, signal
    },
      );
    }
  


export const getSendWebsiteEmbedInstructionsMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendWebsiteEmbedInstructions>>, TError,{platformId: string;data: SendAgelessWebsiteEmbedInstructionsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendWebsiteEmbedInstructions>>, TError,{platformId: string;data: SendAgelessWebsiteEmbedInstructionsRequest}, TContext> => {

const mutationKey = ['sendWebsiteEmbedInstructions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendWebsiteEmbedInstructions>>, {platformId: string;data: SendAgelessWebsiteEmbedInstructionsRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  sendWebsiteEmbedInstructions(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SendWebsiteEmbedInstructionsMutationResult = NonNullable<Awaited<ReturnType<typeof sendWebsiteEmbedInstructions>>>
    export type SendWebsiteEmbedInstructionsMutationBody = SendAgelessWebsiteEmbedInstructionsRequest
    export type SendWebsiteEmbedInstructionsMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Send Ageless website embed setup instructions email to a recipient on
behalf of the requesting admin user. The frontend supplies subject + a
base64-encoded body (base64 keeps the embed snippet's script/inline
handlers opaque so the upstream WAF does not flag the request as XSS and
drop it); the backend decodes the body, prepends a server-controlled
prelude, and sends via the canonical email pipeline with Reply-To set to
the admin's email and the admin BCC'd a copy of the outbound message.
 */
export const useSendWebsiteEmbedInstructions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendWebsiteEmbedInstructions>>, TError,{platformId: string;data: SendAgelessWebsiteEmbedInstructionsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendWebsiteEmbedInstructions>>,
        TError,
        {platformId: string;data: SendAgelessWebsiteEmbedInstructionsRequest},
        TContext
      > => {
      return useMutation(getSendWebsiteEmbedInstructionsMutationOptions(options));
    }
    /**
 * @summary Mints the signed token behind a shareable Ageless Marketing setup link. The link lets a
practice's web developer open the marketing page without a login and set the website-embed
allowlist — and nothing else. It grants no capability the requesting admin does not
already have on this platform, and expires (90 days by default) so a forwarded link
stops working.
 */
export const generateMarketingSetupLink = (
    platformId: string,
    generateAgelessMarketingSetupTokenRequest: GenerateAgelessMarketingSetupTokenRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayGeneratedAgelessMarketingSetupTokenResponse>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/marketing/setup-link`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateAgelessMarketingSetupTokenRequest, signal
    },
      );
    }
  


export const getGenerateMarketingSetupLinkMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateMarketingSetupLink>>, TError,{platformId: string;data: GenerateAgelessMarketingSetupTokenRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateMarketingSetupLink>>, TError,{platformId: string;data: GenerateAgelessMarketingSetupTokenRequest}, TContext> => {

const mutationKey = ['generateMarketingSetupLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateMarketingSetupLink>>, {platformId: string;data: GenerateAgelessMarketingSetupTokenRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  generateMarketingSetupLink(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateMarketingSetupLinkMutationResult = NonNullable<Awaited<ReturnType<typeof generateMarketingSetupLink>>>
    export type GenerateMarketingSetupLinkMutationBody = GenerateAgelessMarketingSetupTokenRequest
    export type GenerateMarketingSetupLinkMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Mints the signed token behind a shareable Ageless Marketing setup link. The link lets a
practice's web developer open the marketing page without a login and set the website-embed
allowlist — and nothing else. It grants no capability the requesting admin does not
already have on this platform, and expires (90 days by default) so a forwarded link
stops working.
 */
export const useGenerateMarketingSetupLink = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateMarketingSetupLink>>, TError,{platformId: string;data: GenerateAgelessMarketingSetupTokenRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateMarketingSetupLink>>,
        TError,
        {platformId: string;data: GenerateAgelessMarketingSetupTokenRequest},
        TContext
      > => {
      return useMutation(getGenerateMarketingSetupLinkMutationOptions(options));
    }
    /**
 * @summary Retrieve Ageless website embed settings for a platform.
 */
export const getWebsiteEmbedSettings = (
    platformId: string,
    params?: GetWebsiteEmbedSettingsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAgelessWebsiteEmbedSettingsResponse>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/website-embed-settings`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetWebsiteEmbedSettingsQueryKey = (platformId: string,
    params?: GetWebsiteEmbedSettingsParams,) => {
    return [
    `/api/v1/ageless/platforms/features/${platformId}/website-embed-settings`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetWebsiteEmbedSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: GetWebsiteEmbedSettingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebsiteEmbedSettingsQueryKey(platformId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>> = ({ signal }) => getWebsiteEmbedSettings(platformId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWebsiteEmbedSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>>
export type GetWebsiteEmbedSettingsQueryError = ErrorType<ProblemDetails>


/**
 * @summary Retrieve Ageless website embed settings for a platform.
 */

export function useGetWebsiteEmbedSettings<TData = Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetWebsiteEmbedSettingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWebsiteEmbedSettingsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Generates a short-lived embed token authorizing an allowlisted parent origin to embed the Ageless website widget for the specified platform.
 */
export const generateWebsiteEmbedToken = (
    platformId: string,
    generateAgelessWebsiteEmbedTokenRequest: GenerateAgelessWebsiteEmbedTokenRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayGeneratedAgelessWebsiteEmbedTokenResponse>(
      {url: `/api/v1/ageless/short-lived/platforms/${platformId}/website-embed-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateAgelessWebsiteEmbedTokenRequest, signal
    },
      );
    }
  


export const getGenerateWebsiteEmbedTokenMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateWebsiteEmbedToken>>, TError,{platformId: string;data: GenerateAgelessWebsiteEmbedTokenRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateWebsiteEmbedToken>>, TError,{platformId: string;data: GenerateAgelessWebsiteEmbedTokenRequest}, TContext> => {

const mutationKey = ['generateWebsiteEmbedToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateWebsiteEmbedToken>>, {platformId: string;data: GenerateAgelessWebsiteEmbedTokenRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  generateWebsiteEmbedToken(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateWebsiteEmbedTokenMutationResult = NonNullable<Awaited<ReturnType<typeof generateWebsiteEmbedToken>>>
    export type GenerateWebsiteEmbedTokenMutationBody = GenerateAgelessWebsiteEmbedTokenRequest
    export type GenerateWebsiteEmbedTokenMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Generates a short-lived embed token authorizing an allowlisted parent origin to embed the Ageless website widget for the specified platform.
 */
export const useGenerateWebsiteEmbedToken = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateWebsiteEmbedToken>>, TError,{platformId: string;data: GenerateAgelessWebsiteEmbedTokenRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateWebsiteEmbedToken>>,
        TError,
        {platformId: string;data: GenerateAgelessWebsiteEmbedTokenRequest},
        TContext
      > => {
      return useMutation(getGenerateWebsiteEmbedTokenMutationOptions(options));
    }
    /**
 * @summary Validates a previously issued Ageless website embed token and returns its associated platform details.
 */
export const validateWebsiteEmbedToken = (
    params?: ValidateWebsiteEmbedTokenParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayValidatedAgelessWebsiteEmbedTokenResponse>(
      {url: `/api/v1/ageless/short-lived/platforms/website-embed-token/validate`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getValidateWebsiteEmbedTokenQueryKey = (params?: ValidateWebsiteEmbedTokenParams,) => {
    return [
    `/api/v1/ageless/short-lived/platforms/website-embed-token/validate`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getValidateWebsiteEmbedTokenQueryOptions = <TData = Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError = ErrorType<ProblemDetails>>(params?: ValidateWebsiteEmbedTokenParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getValidateWebsiteEmbedTokenQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>> = ({ signal }) => validateWebsiteEmbedToken(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData> & { queryKey: QueryKey }
}

export type ValidateWebsiteEmbedTokenQueryResult = NonNullable<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>>
export type ValidateWebsiteEmbedTokenQueryError = ErrorType<ProblemDetails>


/**
 * @summary Validates a previously issued Ageless website embed token and returns its associated platform details.
 */

export function useValidateWebsiteEmbedToken<TData = Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError = ErrorType<ProblemDetails>>(
 params?: ValidateWebsiteEmbedTokenParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getValidateWebsiteEmbedTokenQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieves the generic Ageless host configuration including the admin app base URL.
 */
export const getAgelessHostConfiguration = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAgelessHostConfiguration>(
      {url: `/api/v1/ageless/host-configuration`, method: 'GET', signal
    },
      );
    }
  



export const getGetAgelessHostConfigurationQueryKey = () => {
    return [
    `/api/v1/ageless/host-configuration`
    ] as const;
    }

    
export const getGetAgelessHostConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError = ErrorType<ProblemDetails>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgelessHostConfigurationQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgelessHostConfiguration>>> = ({ signal }) => getAgelessHostConfiguration(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgelessHostConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getAgelessHostConfiguration>>>
export type GetAgelessHostConfigurationQueryError = ErrorType<ProblemDetails>


/**
 * @summary Retrieves the generic Ageless host configuration including the admin app base URL.
 */

export function useGetAgelessHostConfiguration<TData = Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgelessHostConfigurationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




